/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import Moment from 'react-moment';
import { translate } from 'react-i18next';
import moment from 'moment';

import type { TranslatorProps } from 'react-i18next';

import Loading from 'components/Loading/Loading';

import type TypeForm from 'forms/_.extend';

import SiteAddress from 'components/SiteAddress/SiteAddress';
import ElectroDatePicker from 'forms/components/inputs/ElectroDatePicker/ElectroDatePicker';
import ElectroTextField from 'forms/components/inputs/ElectroTextField/ElectroTextField';
import ElectroRadioGroup from 'forms/components/inputs/ElectroRadioGroup/ElectroRadioGroup';
import ElectroCheckbox from 'forms/components/inputs/ElectroCheckbox/ElectroCheckbox';
import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerTable from 'views/ActionDrawer/components/ActionDrawerTable/ActionDrawerTable';

import styles from '../../../../ActionDrawer.module.scss';
import { observable } from 'mobx';
import {
  InputValue,
  InputValues,
} from '../../ReportAssetFault/ReportAssetFaultForm/ReportAssetFaultForm';

type TypeProps = {
  t: TranslatorProps,
  asset: Object,
  assetStore: Object,
  form: TypeForm,
};

@translate()
@inject('assetStore')
@observer
export default class ScheduleCalibrationForm extends React.Component<*> {
  @observable newLocation = false;
  @observable newContactDetails = false;

  onInputChange(value: InputValue) {
    if (
      value === InputValues.NEW_LOCATION ||
      value === InputValues.CURRENT_LOCATION ||
      value === InputValues.CONTRACT_LOCATION
    ) {
      this.newLocation = value === InputValues.NEW_LOCATION;
    }
    if (
      value === InputValues.USER_CONTACT_DETAILS ||
      value === InputValues.CONTRACT_PICKUP_DETAILS ||
      value === InputValues.NEW_CONTACT_DETAILS
    ) {
      this.newContactDetails = value === InputValues.NEW_CONTACT_DETAILS;
    }
  }

  render() {
    const { t, asset, form, assetStore }: TypeProps = this.props;

    const assetDetails: Object = asset.account ? asset : assetStore.asset;

    let assetInfo: Array<*> = [
      [t('general:assets.labels.number'), assetDetails.asset_number],
      [t('general:manufacturer'), assetDetails.manufacturer],
      [t('general:model'), assetDetails.model],
      [t('general:labels.serial_number'), assetDetails.serial_number],
      [
        t('general:calibrations.labels.due'),
        <Moment date={assetDetails.calibration.due_date} format="MMMM DD, YYYY" />,
      ],
    ];

    if (!assetDetails.owned) {
      assetInfo = [
        [
          t('general:trading_account'),
          assetDetails.account && `${assetDetails.account.name} ${assetDetails.account.number}`,
        ],
        [
          t('general:contracts.labels.number'),
          assetDetails.contract && assetDetails.contract.er_contract_number,
        ],
      ].concat(assetInfo);
    }

    if (!assetStore.asset.account) {
      return <Loading />;
    }

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={t('general:assets.labels.details')}
          >
            <ActionDrawerTable data={assetInfo} />
            {!assetDetails.owned && assetDetails.project && (
              <React.Fragment>
                <h5>{t('general:labels.hire_period')}:</h5>
                <ul>
                  <li>
                    <Moment date={assetDetails.project.start_date.date} format="MMMM DD, YYYY" /> to{' '}
                    <Moment date={assetDetails.project.end_date.date} format="MMMM DD, YYYY" />
                  </li>
                </ul>
              </React.Fragment>
            )}

            <div className={styles['clearfix']} />
            <div className={styles['info-block']}>
              <h3>{t('general:assets.labels.current_location')}</h3>
              {assetDetails.location ? (
                <SiteAddress {...assetDetails.location.site.address} />
              ) : (
                <ul>
                  <li>{t('general:search_results.no_location_found')}</li>
                </ul>
              )}
            </div>
          </ActionDrawerBlock>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={form.$('collectionDetails').label}
          >
            <ElectroDatePicker
              field={form.$('collectionDetails.collectionDate')}
              minDate={
                new Date(
                  moment()
                    .add(1, 'd')
                    .format('YYYY-MM-DD')
                )
              }
            />
            {!assetDetails.owned && (
              <React.Fragment>
                <ElectroRadioGroup
                  field={form.$('collectionDetails.collectLocation')}
                  onChange={this.onInputChange.bind(this)}
                />
                {this.newLocation && (
                  <ElectroTextField field={form.$('collectionDetails.newLocation')} />
                )}
                <ElectroRadioGroup
                  field={form.$('collectionDetails.contactDetails')}
                  onChange={this.onInputChange.bind(this)}
                />
                {this.newContactDetails && (
                  <React.Fragment>
                    <ElectroTextField field={form.$('collectionDetails.newContactDetailsName')} />
                    <ElectroTextField field={form.$('collectionDetails.newContactDetailsEmail')} />
                  </React.Fragment>
                )}
              </React.Fragment>
            )}
          </ActionDrawerBlock>
          <ActionDrawerBlock gutters={true} heading={form.$('additionalInformation').label}>
            <ElectroCheckbox field={form.$('additionalInformation.replacementRequired')} />
            <ElectroCheckbox field={form.$('additionalInformation.keepOriginalPackaging')} />
            {!form.$('additionalInformation.keepOriginalPackaging').value && (
              <ElectroTextField
                field={form.$('additionalInformation.packagingDescription')}
                props={{
                  multiline: true,
                  rows: 3,
                }}
              />
            )}
          </ActionDrawerBlock>
        </div>
        <ActionDrawerFormButtons form={form} submitTxt={t('general:actions.schedule')} />
      </React.Fragment>
    );
  }
}
